import {
  Directive,
  EventEmitter,
  HostListener,
  Injectable,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ModalContextService {
  private context = 0;

  get active() {
    return this.context;
  }

  pushContext() {
    this.context++;
  }

  popContext() {
    this.context--;
  }
}

/**
 * Provides the (escape) output for custom handling of the Escape key.
 * Note that <modal> turns Escape presses into (close) events already.
 */
@Directive({ selector: '[modalEscape]' })
export class ModalEscapeDirective implements OnDestroy, OnInit {
  private context: number;

  @Output() escape = new EventEmitter();

  constructor(private readonly modalContext: ModalContextService) {}

  ngOnDestroy() {
    this.modalContext.popContext();
  }

  ngOnInit() {
    this.modalContext.pushContext();
    this.context = this.modalContext.active;
  }

  @HostListener('document:keydown', ['$event'])
  keyDown(event: KeyboardEvent) {
    if (this.modalContext.active === this.context) {
      if (event.keyCode == 27) {
        event.stopPropagation();
        this.escape.emit();
      }
    }
  }
}
